import { useState, useCallback } from 'react';

/**
 * 검색 모달 열기/닫기 상태를 관리하는 커스텀 훅.
 * StockMainPage, StockDetailPage에서 공통으로 사용.
 */
const useSearchModal = () => {
  const [isSearchModalOpen, setIsSearchModalOpen] = useState(false);

  const openSearchModal = useCallback((e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
      e.nativeEvent?.preventDefault();
      e.nativeEvent?.stopImmediatePropagation();
    }
    setIsSearchModalOpen(true);
    return false;
  }, []);

  const closeSearchModal = useCallback((e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
      e.nativeEvent?.preventDefault();
      e.nativeEvent?.stopImmediatePropagation();
    }
    setIsSearchModalOpen(false);
    return false;
  }, []);

  return { isSearchModalOpen, openSearchModal, closeSearchModal };
};

export default useSearchModal;
